import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./SearchBar.css";

const SearchBar = ({ placeholder, setSearchText }) => {
  return (
    <div className="isecurion_search_bar_container">
      <div className="isecurion_search_bar_icon_container">
        <Icon
          icon="ic:round-search"
          width="24"
          height="24"
          color="#E76A34"
          className="isecurion_search_bar_icon"
        />
        <input
          type="text"
          placeholder={placeholder}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchBar;